var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M496 176V16H16V176H496Z",
    fill: "#3498DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M496 336V176H16V336H496Z",
    fill: "#222222"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M496 496V336H16V496H496Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEe);
export default __webpack_public_path__ + "static/media/EE.4fb327f201a3596084eb99c32ee9660c.svg";
export { ForwardRef as ReactComponent };